import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, timer, from, throwError} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import { RateWithRebate } from './model/rate-with-rebate';
import { HttpService } from "../services/http-service";

@Injectable()
export class CurrencyRateService {
    static refreshTime = 15;
    static currentRatesSubject: BehaviorSubject<RateWithRebate[] | number> = new BehaviorSubject<RateWithRebate[] | number>(null);
    static loaded = false;
    static currentRates = null;

    constructor(private httpService: HttpService) {
        if (!CurrencyRateService.loaded) {
            CurrencyRateService.loaded = true;
                timer(0, 1000)
                .pipe(switchMap((a) => (a % CurrencyRateService.refreshTime > 0) ? from([CurrencyRateService.refreshTime - (a % CurrencyRateService.refreshTime)]) : this.getCurrencyRatesWithRebate() as Observable<RateWithRebate[] | number>))
                .subscribe(rates => {
                    if (typeof rates !== 'number') {
                        CurrencyRateService.currentRates = rates;
                    }

                    CurrencyRateService.currentRatesSubject.next(rates);
                });
        }
    }

    getCurrencyRatesSubject() {
        return CurrencyRateService.currentRatesSubject;
    }

    getAllCantorCurrencies(): Observable<any> {
        return this.httpService
            .get('/api/currency/all-exchange-currencies')
            .pipe(catchError(this.handleError));
    }

    getCurrencyRatesWithRebate(): Observable<RateWithRebate[]> {
        return this.httpService
            .get('/api/currency/rates-with-rebate')
            .pipe(
                map((res: any) => {
                    return res.map(item => {
                        return new RateWithRebate(
                            item.Buy,
                            item.BuyChange,
                            item.Sale,
                            item.SaleChange,
                            item.BuyWithRebate,
                            item.SaleWithRebate,
                            item.FlagPrefix,
                            item.Symbol
                        );
                    });
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return throwError(errMsg);
    }
}
